<template>
  <div>
    <FormBuilder :formData="formData" :formValue="formValue"></FormBuilder>
    <Modal title="Copy visit schedule" ref="modalCopyVisitSchedule" :formValue="formValue">
      <div class="close"></div>
      <i>Warning, you cannot undo this copying, so please be careful about selecting treatment groups.</i>
      <form v-on:submit="onCopyVisitScheduleSubmit">
        <div class="input" type="select">
          <label>
            <span>Select treatmentgroup from</span>
            <select v-model="copyDispensingScheduleFromTreatmentGroupId">
              <option value="" disabled selected>Select treatment group</option>
              <option v-for="treatmentGroup in formValue.treatmentGroups"
                      :value="treatmentGroup.id">
                {{treatmentGroup.name}}
              </option>
            </select>
          </label>
        </div>
        <div class="input" type="select">
          <label>
            <span>Select treatmentgroup to</span>
            <select v-model="copyDispensingScheduleToTreatmentGroupId">
              <option value="" disabled selected>Select treatment group</option>
              <option v-for="treatmentGroup in formValue.treatmentGroups"
                      :value="treatmentGroup.id">
                {{treatmentGroup.name}}
              </option>
            </select>
          </label>
        </div>
        <div class="input" type="checkbox">
          <label class="radio">
            <input type="checkbox" v-model="copyDispensingScheduleClearToGroup">
            <small>Clear target schedule group</small>
          </label>
        </div>
     
        <button class="right edit">Copy dispensing schedules</button>
      </form>
    </Modal>
  </div>
</template>

<script>
    import FormBuilder from "../../FormBuilder.vue"
    import Modal from "../../Modal.vue";

    export default {
        components: {
          Modal,
            FormBuilder
        },
        props: {
            formValue: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                copyDispensingScheduleToTreatmentGroupId: "",
                copyDispensingScheduleFromTreatmentGroupId: "",
                copyDispensingScheduleClearToGroup: false,
                formData: [
                    {
                        title: "General",
                        anchor: "2.1",
                        forms: [{
                            type: "calendar",
                            label: "Start date",
                            placeholder: "",
                            value: "start",
                            helper: "Ensure that the assigned start date for each site is a date that is after the study start date",
                            required: true
                        },
                          {
                            type: "calendar",
                            label: "Create snapshot date",
                            value: "generateSnapshotDate",
                            style: this.getSnaphShotDateStyle(),
                            helper: "This is used to create a snapshot for a specific date, so you can download inventory for this date.",
                            required: false
                          },
                          {
                            type: "button",
                            buttonText: "Set sites (3.1) with invalid start dates to study start date",
                            extraClass: "no-image inlineblock",
                            callback: this.correctSiteDates
                        }, {
                            type: "button",
                            buttonText: "Set all site (3.1) start dates to study start date",
                            extraClass: "no-image inlineblock",
                            callback: this.forceSiteDates
                        }/*, {
                            type: "label",
                            label: "Study interval",
                            value: "studyInterval",
                            helper: "The Interval represents the output format the graphs will be displayed in. The interval is selected on a program level."
                        }*/, {
                            type: "textarea",
                            label: "Description",
                            value: "description"
                        }]
                    }, {
                        title: "Enrolment Targets",
                        description: "Anticipated number of subjects to be enrolled",
                        anchor: "2.2",
                        grid: "grid-50w",
                        forms: [{
                            type: "number",
                            label: "Anticipated number of subjects to be enrolled",
                            value: "targetSubjectEnrolment.value",
                            inline: "Subjects",
                            required: true
                        }, {
                            type: "number",
                            label: "Expected study dropout rate",
                            value: "targetSubjectEnrolment.dropoutRate",
                            inline: "Percent (%)"
                        }]
                    }, {
                        title: "Enrolment Categorization",
                        description: "Define enrolment categories for grouping of sites",
                        anchor: "2.3",
                        forms: [{
                            type: "sectionarray",
                            label: "Enrolment Projection Categories",
                            value: "projectionCategories",
                            helper: "An enrolment projection category is used for sorting clinical sites into a defined enrolment interval",
                            grid: "grid-50w",
                            buttonText: "New Enrolment Projection Category",
                            forms: [{
                                type: "text",
                                label: "Name",
                                value: "name"
                            }, {
                                type: "hidden",
                                value: "duration",
                                preValue: "28.00:00:00"
                            }, {
                                type: "section",
                                label: "Enrolment",
                                extraClass: "grid-full",
                                forms: [{
                                    type: "number",
                                    label: "Min.",
                                    value: "enrolmentRate.minimum"
                                }, {
                                    type: "number",
                                    label: "Max.",
                                    value: "enrolmentRate.maximum"
                                }]
                            }]
                        }]
                    }, {
                        title: "Enrolment Suspend Period",
                        description: "Define suspension periods",
                        anchor: "2.4",
                        forms: [{
                            type: "sectionarray",
                            label: "Suspension Periods",
                            value: "enrolmentSuspensions",
                            helper: "A suspension period is triggered after a certain number of subjects has been enrolled, whereafter it suspends further enrolment for the given duration",
                            grid: "grid-50w",
                            buttonText: "New Enrolment Suspend Period",
                            forms: [{
                                type: "text",
                                label: "Name",
                                value: "description"
                            }, {
                                type: "number",
                                label: "Duration",
                                value: "duration",
                                inline: "Days"
                            }, {
                                type: "number",
                                label: "Trigger",
                                value: "subjectTrigger",
                                inline: "Subjects"
                            }]
                        }]
                    }, {
                        title: "Treatment Groups / Weight Groups / Parallel Cohorts",
                        description: "Define treatment / weight group(s) and their ratio. Create a separate study to control cohorts that are not running in parallel.",
                        anchor: "2.5",
                        forms: [{
                            type: "sectionarray",
                            label: "Treatment Groups",
                            value: "treatmentGroups",
                            buttonText: "New Treatment Group",
                            grid: "grid-50w",
                            callback: this.handleDeletedTreatmentGroup,
                            forms: [{
                                type: "guid",
                                value: "id"
                            }, {
                                type: "text",
                                label: "Name",
                                value: "name",
                                required: true
                            }, {
                                type: "number",
                                label: "Ratio",
                                value: "ratio",
                                helper: "Add the ratio or percentage of how many subjects will be assigned to the treatment group",
                                required: true
                            }, {
                                type: "sectionarray",
                                label: "Dispensing Units",
                                extraClass: "grid-full",
                                buttonText: "Associate Dispensing Unit",
                                helper: "Associate one or more dispensing units to the treatment group",
                                value: "dispensingUnits",
                                callback: () => {
                                    // Trigger update
                                    this.changeTreatmentGroups();
                                },
                                forms: [{
                                    type: "guid",
                                    value: "uniqueId"
                                }, {
                                    type: "select",
                                    label: "Associate Dispensing Unit",
                                    value: "id",
                                    callback: () => {
                                        // Trigger update
                                        this.changeTreatmentGroups();
                                    },
                                    required: true,
                                    preValues: {
                                        field: "dispensingUnits",
                                        name: "name",
                                        value: "id",
                                        valueName: "name"
                                    }
                                }]
                            }]
                        }]
                    }, {
                        title: "Dosage Regimens",
                        description: "Setup a dosage regimen for each treatment group, including titration rules",
                        anchor: "2.6",
                        forms: [{
                            type: "sectionarray",
                            label: "",
                            value: "treatmentGroups",
                            extraClass: "hide-add",
                            disableDelete: false,
                            forms: [{
                                type: "text",
                                label: "Treatment Group",
                                value: "name",
                                disabled: true
                            }, {
                                type: "sectionarray",
                                label: "Dosage Regimens",
                                value: "dosageRegimens",
                                buttonText: "New Dosage Regimen",
                                grid: "grid-50w",
                                forms: [{
                                    type: "select",
                                    label: "Dosage Form",
                                    value: "dosage.dosageFormReference.id",
                                    required: true,
                                    preValues: {
                                        "field": "dosageForms",
                                        "name": "name",
                                        "value": "id"
                                    }
                                }, {
                                    type: "number",
                                    label: "Start day within total treatment period",
                                    helper: "The first day in the total treatment period the dosage form is administered",
                                    value: "startDuration",
                                    inline: "Day",
                                    minValue: 1,
                                    required: true
                                }, {
                                    type: "number",
                                    label: "Treatment period for the dosage form",
                                    helper: "Number of days the patient is treated with the dosage form",
                                    value: "duration",
                                    required: true,
                                    inline: "Days"
                                }, {
                                    type: "number",
                                    label: "Time between administration",
                                    helper: "Days between each administration of the dosage form",
                                    value: "dosage.frequency",
                                    required: true,
                                    inline: "Days"
                                }, {
                                    type: "number",
                                    label: "Number of dosage form per administration",                                   
                                    value: "dosage.quantity",
                                    required: true
                                },
                                  {
                                    type: "void"
                                  },
                                  {
                                    type: "select",
                                    label: "Primary Package",
                                    value: "primaryPackagingId",
                                    required: true,
                                    preValues: "primaryPackages"
                                  }
                                  ,
                                  {
                                    type: "select",
                                    label: "Secondary Package",
                                    value: "secondaryPackagingId",
                                    required: true,
                                    preValues: "secondaryPackages"
                                  }
                                  ,
                                  {
                                    type: "select",
                                    label: "Dispensing Unit",
                                    value: "dunId",
                                    required: true,
                                    preValues: "dispensingUnits"
                                  }
                               
                                
                                ]
                            }]
                        }]
                    }, {
                        title: "Dispensing Schedules",
                        description: "Define dispensing schedule for each treatment group",                     
                        anchor: "2.7",
                        forms: [{
                            type: "sectionarray",
                            label: "Dispensing Schedules",
                            value: "treatmentGroups",
                            buttonText: "New Dispensing schedule",
                            extraClass: "hide-add",
                            disableDelete: false,
                            grid: "grid-50w",
                            forms: [{
                                type: "text",
                                label: "Name",
                                value: "visitSchedule.name",
                                required: true
                            }, {
                                type: "text",
                                label: "Treatment group Name",
                                value: "name",
                                disabled: true
                            }, {
                                type: "number",
                                label: "Total Treatment Period",
                                value: "visitSchedule.treatmentPeriod",
                                inline: "Days",
                                required: true
                            },
                              {
                                type: "sectionarray",
                                label: "Visits",
                                extraClass: "grid-full",
                                buttonText: "Add Visit",
                                value: "visitSchedule.visits",
                                grid: "grid-50w",
                                callback: () => {
                                    // Trigger update
                                    this.changeTreatmentGroups();
                                },
                                forms: [{
                                    type: "text",
                                    label: "Name",
                                    value: "name",
                                    required: true
                                }, {
                                    type: "number",
                                    label: "Study Day",
                                    value: "studyDays",
                                    minValue: 1,
                                    helper: "Study day starts at day 1 (one). It is not zero based.",
                                    required: true
                                }, {
                                    type: "section",
                                    label: "Visit Windows",
                                    extraClass: "grid-full hide-add",
                                    forms: [{
                                        type: "number",
                                        label: "Before",
                                        value: "windowlongerval.before",
                                        inline: "Days",
                                        required: false
                                    }, {
                                        type: "number",
                                        label: "After",
                                        value: "windowlongerval.after",
                                        inline: "Days",
                                        required: false
                                    }]
                                }, {
                                    type: "sectionarray",
                                    label: "Dispensing Units",
                                    extraClass: "grid-full hide-add",
                                    buttonText: "Associate dispensing unit",
                                    value: "visitDispensingUnitConfigurations",
                                    disableDelete: true,
                                    grid: "grid-50w",
                                    forms: [{
                                        type: "select",
                                        label: "Dispensing Unit",
                                        value: "dispensingUnit",
                                        disabled: true,
                                        preValues: {
                                            field: "dispensingUnits",
                                            name: "name",
                                            value: "id",
                                            valueName: "name"
                                        }
                                    }, {
                                        type: "checkbox",
                                        label: "Dispense",
                                        value: "dispense"
                                    }, {
                                        type: "number",
                                        label: "Extra Dispensing Units",
                                        value: "extraDispensingUnits",
                                        allowNegative: true
                                    }]
                                }]
                            }]
                        }, 
                          {
                          type: "button",
                          buttonText: "Copy schedule",
                          callback: () => {
                            this.copyDispensingScheduleModal();
                          }
                        } ]
                    }]
            }
        },
        mounted() {
            // For legacy json on some old studies: Set new DUN id
            if (!this.formValue.treatmentGroups)
                return;

            for (let tg of this.formValue.treatmentGroups) {

                for (let visit of tg.visitSchedule.visits) {

                    for (let config of visit.visitDispensingUnitConfigurations) {

                        // If dispensingUnitReference is not found, this is a new study. Just skip
                        if (!config.dispensingUnitReference)
                            continue;

                        // Add new properties
                        config.dispensingUnit = config.dispensingUnitReference.id;                       

                        // Delete old properties
                        delete config.dispensingUnitReference;
                    }
                }
            }

            // 02/08/2019 trigger update because of aggregation data
            this.changeTreatmentGroups();
        },
        methods: {
          copyDispensingScheduleModal() {
            
        
           
                    this.$refs.modalCopyVisitSchedule.show();
          
            },
            // Copy visit schedule from static template
          onCopyVisitScheduleSubmit(e) {
              e.preventDefault();
                this.isLoading = true;
                console.log("Copying from " + this.copyDispensingScheduleFromTreatmentGroupId)
                console.log("Copying to " + this.copyDispensingScheduleToTreatmentGroupId)
            
                const fromScheduleTG = this.formValue.treatmentGroups.find(x => x.id === this.copyDispensingScheduleFromTreatmentGroupId);
                const toScheduleTG = this.formValue.treatmentGroups.find(x => x.id === this.copyDispensingScheduleToTreatmentGroupId);
                 
                if (!fromScheduleTG || !toScheduleTG) {
                    alert("Please select both treatment groups.");
                    this.isLoading = false;
                    return;
                }
                
                if (fromScheduleTG.id === toScheduleTG.id) {
                    alert("You cannot copy from and to the same treatment group.");
                    this.isLoading = false;
                    return;
                }
                
                const visitSchedule = toScheduleTG.visitSchedule;
                if (!visitSchedule) {
                    alert("The selected destination treatment group does not have a visit schedule.");
                    this.isLoading = false;
                    return;
                }
                
                if (!visitSchedule.visits || this.copyDispensingScheduleClearToGroup) {
                    visitSchedule.visits = [];
                }
              
             
                for (let visit of fromScheduleTG.visitSchedule.visits) {
                  
                  const newVisit = JSON.parse(JSON.stringify(visit));
  
                  visitSchedule.visits.push(newVisit);
                 
                 
                }
                
                this.isLoading = false;
                this.$refs.modalCopyVisitSchedule.hide();
                
               
            },    
            getSnaphShotDateStyle() {
                if (!this.isSuperAdmin())
                {
                    return "display:none;"
                }
                
                return "";
            },
            isSuperAdmin() {
              return this.$store.state.member.isSuperAdmin;
            },
            handleDeletedTreatmentGroup(item,data,formValue,isDeleted) {
                if (!isDeleted)
                  return;
            },
            changeTreatmentGroups() {
                this.formValue.treatmentGroups.forEach((group) => {

                    if (!group.visitSchedule) {
                        group.visitSchedule = {};
                        group.visitSchedule.visits = [];
                    }

                    // 2.7 Dispensing Schedules
                    group.visitSchedule.visits.forEach((visit) => {

                        let list = [];
                        group.dispensingUnits.forEach((dispensingUnit) => {

                            // Check if DUN is already added
                            let oldDun = visit.visitDispensingUnitConfigurations.find(x => x.dispensingUnit == dispensingUnit.id);

                            let newUnit = {
                                dispensingUnit: dispensingUnit.id,                               
                                dispense: oldDun ? oldDun.dispense : false,
                                extraDispensingUnits: oldDun ? oldDun.extraDispensingUnits : 0
                            };
                            list.push(newUnit);
                        });

                        visit.visitDispensingUnitConfigurations = list;

                    });

                    // 02/08/2019 last minute fix - PrimaryPackageId cannot be set in backend anymore, because of aggregation data
                    // All unique PrimaryPackageIds must be set here, otherwise forecast tool will not run
                    group.dispensingUnits.forEach((dispensingUnit) => {
                        let uniqueIdList = [];

                        for (let secPack of this.formValue.secondaryPackages) {
                            uniqueIdList.push(this.$uuid.v4())
                        }

                        dispensingUnit["uniquePrimaryPackageIds"] = uniqueIdList;
                    });

                });
            },
            correctSiteDates() {
                var form = this.formValue;
                var start = form.start;
                var startDate = new Date(start);

                var invalidDates = 0;
                var sites = [];

                for (var i = 0; i < form.sites.length; i++) {
                    var site = form.sites[i];
                    var date = new Date(site.start);

                    if (date == "Invalid Date" || date < startDate) {
                        invalidDates++;
                        sites.push(site);
                    }
                }

                if (invalidDates === 0) {
                    alert(`There are no invalid dates. Nothing to set.`)
                    return;
                }

                var msg = invalidDates === 1 ? "There is 1 invalid date. Overwrite with the current study start date?" : `There are ${invalidDates} invalid dates. Overwrite these with the current study start date?`;

                if (confirm(msg)) {
                    for (var i = 0; i < sites.length; i++) {
                        var site = sites[i];
                        site.start = start;
                    }

                    this.$store.dispatch("saveCurrentForecastVersion");
                }
            },
            forceSiteDates() {
                var form = this.formValue;
                var start = form.start;
                var sites = form.sites;

                if (confirm(`This will overwrite the dates of all ${sites.length} sites with the current study start date. Continue?`)) {
                    for (var i = 0; i < sites.length; i++) {
                        var site = sites[i];
                        site.start = start;
                    }

                    this.$store.dispatch("saveCurrentForecastVersion");
                }
            }
        }
    }
</script>